const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const RSP_ENGLISH_MUSIC =
  'https://cdn.shopify.com/s/files/1/0718/8768/3702/files/vadim_makes_sound-peace-01-dark-alt-rampb-554210.mp3?v=1789583606';
const RSP_SPANISH_MUSIC =
  'https://cdn.shopify.com/s/files/1/0718/8768/3702/files/RSP_Spanish_Un_Amor_Perdido_Web_Loop.mp3?v=1789523094';

function setupRSPMusic() {
  const audio = document.getElementById('rspMusic');
  if (!audio) return;

  const isSpanish = document.documentElement.lang.toLowerCase().startsWith('es');
  const desiredSource = isSpanish ? RSP_SPANISH_MUSIC : RSP_ENGLISH_MUSIC;
  const source = audio.querySelector('source');
  if (!source) return;

  const currentSource = source.getAttribute('src') || '';
  if (currentSource === desiredSource) return;

  source.setAttribute('src', desiredSource);
  audio.load();
}

function setupStoryVideo(root) {
  const video = root.querySelector('[data-rsp-story-video] video');
  const soundButton = root.querySelector('[data-rsp-sound-toggle]');
  const playButton = root.querySelector('[data-rsp-play-video]');
  if (!video) return;
  if (root.dataset.rspVideoReady === 'true') return;
  root.dataset.rspVideoReady = 'true';

  if (root.dataset.rspVideoMode === 'manual') {
    playButton?.addEventListener('click', () => {
      video
        .play()
        .then(() => {
          root.classList.add('is-playing');
          video.controls = true;
        })
        .catch(() => {});
    });
    return;
  }

  const updateSoundLabel = () => {
    if (!soundButton) return;
    soundButton.textContent = video.muted
      ? soundButton.dataset.soundOn
      : soundButton.dataset.soundOff;
    soundButton.setAttribute('aria-pressed', String(!video.muted));
  };

  soundButton?.addEventListener('click', () => {
    video.muted = !video.muted;
    updateSoundLabel();
    if (!reducedMotion.matches) video.play().catch(() => {});
  });

  updateSoundLabel();
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry) return;
      if (entry.isIntersecting && !reducedMotion.matches) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    },
    { threshold: 0.35 },
  );
  observer.observe(video);
}

function initRSP(root = document) {
  setupRSPMusic();
  root.querySelectorAll('[data-rsp-story]').forEach(setupStoryVideo);
  if (reducedMotion.matches) {
    root.querySelectorAll('.rsp-hero video').forEach((video) => video.pause());
  }
}

document.addEventListener('DOMContentLoaded', () => initRSP());
document.addEventListener('shopify:section:load', (event) => initRSP(event.target));

